import React, { memo, useMemo } from 'react';
import { useTranslation } from "core/hooks/useTranslation";

import { Button } from 'antd';

import Modal from "core/ui-kit/modal";
import Icon from 'core/ui-kit/icon';
import Table from 'components/common/table';

import { POPUP_SIZE } from "core/constants/common";

import { failedModalcolumns } from './columns';
import { tableColumnsCreator } from 'utils/tableColumnsCreator';
import showSuccess from 'core/helpers/common/showSuccess';


const FailureModal = ({
    isVisible,
    data,
    onClose
}) => {
    const { t } = useTranslation();

    const { mainTableColumns } = useMemo(() => {
        return tableColumnsCreator({
            mainColumns: failedModalcolumns,
            t
        });
    }, [t])

    const affiliatesData = useMemo( () => {
        return data?.failedAffiliates ?? []
    }, [data])

    const handleCopy = () => {
        let text = "";
        affiliatesData.forEach(affiliate => {
            text += `${t("backoffice.affiliates.id")}: ${affiliate.longId}, ${t("backoffice.affiliates.userName")}: ${affiliate.userName}\n`
        })
        
        navigator.clipboard.writeText(text)
            .then(() => {
                showSuccess(t('backoffice.common.copied'));
            })
    }

    return (
        <Modal
            open={isVisible}
            title={ t('backoffice.campaigns.failedToAdd') }
            cancelText={t('backoffice.common.close')}
            onCancel={onClose}
            size={POPUP_SIZE.BIGER}
            okButtonProps={{hidden: true}}
            className="rt--campaigns-affiliates-result-modal"
        >
            <div className='rt--campaigns-affiliates-result-copy rt--flex rt--justify-end'>
                <div 
                    className='rt--flex rt--align-center rt--p-4 rt--pb-4 rt--pl-8 rt--pr-8 rt--mb-16 rt--campaigns-affiliates-result-copy-button'
                    onClick={handleCopy}
                >
                    <Icon name="copy" />
                    <span className='rt--title rt--pl-8 rt--pr-8 rt--font-bold'>{t("backoffice.common.copy")}</span>
                </div>
            </div>
            <Table
                columns={mainTableColumns}
                data={affiliatesData}
                disableFullView={true}
                noPagination={true}
            />

            <div className="rt--pl-16 rt--pt-16 rt--pb-16 rt--pr-16 rt--campaigns-affiliates-result">
                <div className='rt--flex rt--align-center rt--justify-end rt--campaigns-affiliates-result-failed'>
                    <span className='rt--title rt--font-regular rt--font-small'>{t("backoffice.campaigns.failedToAdd")}:</span>
                    <b className='rt--title rt--font-bold rt--font-small rt--pl-2'>{data?.failureCount}</b>
                </div>
                <div className='rt--flex rt--align-center rt--justify-end rt--campaigns-affiliates-result-success'>
                    <span className='rt--title rt--font-regular rt--font-small'>{t("backoffice.campaigns.successfullyAddedAffiliates")}:</span>
                    <b className='rt--title rt--font-bold rt--font-small rt--pl-2'>{data?.successCount}</b>
                </div>
            </div>
        </Modal>
        
    )
}

export default memo(FailureModal);